import React, { useEffect, useState, Fragment } from "react";
import Fade from "@material-ui/core/Fade";
import loadImage from "blueimp-load-image";
import CircularProgress from "@material-ui/core/CircularProgress";
import Firebase from "../../../firebasehelper";
import FileUpload from "../../../components/ContentUpload/FileUpload";
import DateTimePicker from "../../../components/DateTimePicker";
import { default_offer } from "../constants/default";
import {
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  GIF_UPLOAD,
} from "../../../Constants/types";
import {
  UPLOADING_VIDEO,
  UPLOADING_IMAGE,
  UPLOADING_GIF,
} from "../../../Constants/string";
import "./AddPerkModal.css";

const AddPerkForm = ({ onChange }) => {
  const [loading, setLoading] = useState(false);
  const [loading_script, setLoadingScript] = useState("");
  const [perk, setPerk] = useState(default_offer);
  useEffect(() => {
    onChange(perk);
  }, [perk]);
  const updatePerkName = ({ target }) => {
    perk.perkName = target.value;
    setPerk({ ...perk });
  };
  const uploadContent = (fieldName) => async (content) => {
    let uploadFolder = "perks";
    const title = perk.perkName || new Date().getTime().toString();
    setLoading(true);
    const { mediaType, mediaContent } = content;
    try {
      if (mediaType === GIF_UPLOAD || mediaType === IMAGE_UPLOAD) {
        setLoadingScript(
          mediaType === IMAGE_UPLOAD ? UPLOADING_IMAGE : UPLOADING_GIF
        );
        let media_url = await Firebase.uploadImage(
          mediaContent,
          title,
          uploadFolder + "/images"
        );
        setLoading(false);
        perk[fieldName] = media_url;
        perk[`${fieldName}_type`] = mediaType;
        setPerk({ ...perk });
      } else if (mediaType === VIDEO_UPLOAD) {
        const uploadTask = Firebase.uploadVideo(
          mediaContent,
          uploadFolder + "/videos"
        );
        uploadTask.on(
          "state_changed",
          handleUploadProgress,
          handleUploadError,
          () => {
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              setLoading(false);
              setLoadingScript("");
              perk[fieldName] = downloadURL;
              perk[`${fieldName}_type`] = mediaType;
              setPerk({ ...perk });
            });
          }
        );
      }
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };
  const handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loading_script = UPLOADING_VIDEO + " " + progress + "%";
    setLoadingScript(loading_script);
  };
  const handleUploadError = (error) => {
    setLoadingScript("");
    setLoading(false);
  };
  return (
    <div className="perk-form">
      <h5 className="section-title">Offer title</h5>
      <input
        className="form-control form-control-md "
        name="retailerName"
        placeholder="Input insider perk name here..."
        onChange={updatePerkName}
      />
      <h5 className="section-title">Offer thumbnail</h5>
      <FileUpload onChangeContent={uploadContent("perkThumbnail")} />
      <h5 className="section-title">Promotion banner</h5>
      <FileUpload onChangeContent={uploadContent("perkBanner")} />
      <h5 className="section-title">Promotion Logo</h5>
      <FileUpload onChangeContent={uploadContent("perkLogo")} />
      <Fade
        in={loading}
        style={{
          transitionDelay: loading ? "800ms" : "0ms",
        }}
        unmountOnExit
      >
        <Fragment>
          <p>{loading_script}</p>
          <CircularProgress />
        </Fragment>
      </Fade>
    </div>
  );
};
export default AddPerkForm;



// WEBPACK FOOTER //
// ./src/screens/Perks/components/AddPerkForm.js